<script>
import alert from "../../helpers/alert";
import http from "../../helpers/http";

export default {
  name: "BtnCallQueueArrival",
  props: ['scheduleEdit', 'classes', 'btnText'],
  emits: ['onCallQueueArrival'],
  computed: {
    place() {
      return this.$store.state.auth.place;
    },
    userAuth() {
      return this.$store.state.auth.user;
    },
    terminal() {
      return this.$store.state.auth.terminal;
    }
  },
  methods: {
    date: moment,
    callPatient(schedule) {
      http.patch(`/places/${this.place.id_place}/queue-arrivals/${this.terminal.id_terminal}/call/${schedule.id_queue_arrival}`).then(response => {
        this.scheduleEdit.called_at = response.data.called_at;
        alert.toastSuccess('Paciente chamado com sucesso!');
      }).catch(error => {
        alert.toastError('Erro ao chamar paciente!');
        console.error('Erro ao chamar paciente:', error);
      });
    },
  }
}
</script>

<template>
  <button
      v-show="terminal?.id_terminal && scheduleEdit?.id_queue_arrival && (scheduleEdit?.sched_status === 'CO' || scheduleEdit?.sched_status === 'AG' || scheduleEdit?.sched_arrive) && !scheduleEdit.sched_end && date(scheduleEdit?.schedule_date_time).isSame(date(), 'day')"
      @click.stop="this.callPatient(scheduleEdit)"
      type="button"
      :title="scheduleEdit?.called_at ? 'Rechamar paciente' : 'Chamar paciente'"
      class="btn me-2 btn-flex"
      :class="'bi bi-megaphone ' + `${scheduleEdit?.called_at ? 'btn-outline-call' : 'btn-call blink'}`">
    {{ btnText ?? '' }}
  </button>
</template>

<style scoped>
@keyframes blink {
  0%, 100% { opacity: 1; }
  50% { opacity: 0; }
}
.blink {
  animation: blink 1s steps(2, start) infinite;
}
.btn-call {
  background-color: #009ef7;
  color: white !important;
}
.btn-outline-call {
  border: 1px solid #009ef7 !important;
  color: #009ef7 !important;
}
.btn-outline-call:hover {
  background-color: rgba(0, 158, 245, 0.2);
  border: 1px solid #009ef7 !important;
  color: #009ef7 !important;
}
</style>